export default "__VITE_ASSET__DlYgORTp__"